import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import axios from "axios";
import React, { Component } from "react";
import DatePicker from "../../../Shared/DatePicker/datePicker";
import {
  filter_whitelist,
  categorization_filter_whitelist,
  merchant_status,
  report_types,
  months,
} from "../../configs/config";
import subDays from "date-fns/subDays";

import "../../styles/MerchantReports.scss";

const get_years = () => {
  var getCurrentYear = new Date().getFullYear();
  var listOfYears = Array.from({ length: 6 }, (_, i) => ({
    name: getCurrentYear - i,
    id: getCurrentYear - i,
  }));

  return listOfYears;
};
const mdo_types = [
  { id: "MAO", name: "MAO" },
  { id: "MMO", name: "MMO" },
];

const config = {
  year: {
    label: "Change Year",
    key: "year",
    options: get_years(),
    value: new Date().getFullYear(),
  },
  month: {
    label: "Select month",
    key: "month",
    options: months,
    value: "",
  },
  report_type: {
    label: "Select report type",
    key: "report_type",
    options: report_types,
    value: "",
  },
  transaction_date: {
    label: "Transaction date",
    key: "transaction date",

    value: "",
    type: "date-picker",
    minDate: "01-09-1950",
    maxDate: subDays(new Date(), 1),
  },
  business_unit: {
    label: "Select business unit",
    key: "business_unit",
    options: [],
    paramTag: "business_unit",
    type: "multi-select",
    value: [],
  },
  sub_unit: {
    label: "Select business sub-unit",
    key: "sub_unit",
    options: [],
    paramTag: "sub_unit",
    type: "multi-select",
    value: [],
  },
  regions: {
    label: "Select region",
    key: "regions",
    options: [],
    paramTag: "region",
    childKey: "areas",
    childApiPoint: "organizations/api/v1/areas",
    type: "multi-select",
    value: [],
  },
  areas: {
    label: "Select area",
    key: "areas",
    options: [],
    //disabledLabel: "Select an region first",
    paramTag: "area",
    childKey: "territories",
    childApiPoint: "organizations/api/v1/territories",
    type: "multi-select",
    value: [],
  },
  territories: {
    label: "Select territory",
    key: "territories",
    options: [],
    // disabledLabel: "Select an area first",
    paramTag: "territory",
    childKey: "agency",
    childApiPoint: "organizations/api/v1/agency",
    type: "multi-select",
    value: [],
  },
  agency: {
    label: "Select agency",
    key: "agency",
    options: [],
    //disabledLabel: "Select an territory first",
    childKey: "field_force",
    childApiPoint: "admin_panel/v1/mdo-list",
    paramTag: "agency",
    type: "multi-select",
    value: [],
  },

  field_force: {
    label: "Select field-force",
    key: "field_force",
    options: [],

    //disabledLabel: "Select an territory first",
    type: "multi-select",
    value: [],
  },
  reg_start_date: {
    label: "Registration start date",
    key: "reg_start_date",

    value: "",
    type: "date-picker",
    minDate: "01-09-1950",
    maxDate: subDays(new Date(), 1),
  },
  reg_end_date: {
    label: "Registration end date",
    key: "reg_end_date",

    value: "",
    type: "date-picker",
    minDate: "01-09-1950",
    maxDate: subDays(new Date(), 1),
  },
  status: {
    label: "Select merchant status",
    key: "status",
    options: merchant_status,
    //disabledLabel: "Select an territory first",
    type: "multi-select",
    value: [],
  },
};
export default class CategorizationFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: { ...config },
      businessUnits: {},
    };
  }
  componentDidMount() {
    this.fetchOptions("regions", "organizations/api/v1/regions", "");
    this.fetchBusinessUnits();
  }

  regenerateSubUnitOptions = (units) => {
    var subUnits = [];
    console.log(this.state.businessUnits);

    units.map((unit) => {
      this.state.businessUnits[unit].map((item) => {
        subUnits.push({ id: item, name: item });
      });
    });

    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        sub_unit: {
          ...prevState.form["sub_unit"],
          options: [...subUnits],
        },
      },
    }));
  };

  handleChange = (e, key) => {
    this.setState(
      (prevState) => ({
        form: {
          ...prevState.form,
          [key]: { ...prevState.form[key], value: e.target.value },
        },
      }),
      () => {
        this.props.callBack({ ...this.state.form });
        if (this.state.form[key].childApiPoint) {
          const endPoint = this.state.form[key].childApiPoint;
          const param = `?${this.state.form[key].paramTag}=${e.target.value}`;
          this.fetchOptions(this.state.form[key].childKey, endPoint, param);
        }
      }
    );
  };

  handleMultipleSelectChange = (e, key) => {
    if (key === "business_unit") this.regenerateSubUnitOptions(e.target.value);
    this.setState(
      (prevState) => ({
        form: {
          ...prevState.form,
          [key]: { ...prevState.form[key], value: e.target.value },
        },
      }),
      () => {
        this.props.callBack({ ...this.state.form });
        if (this.state.form[key].childApiPoint) {
          const endPoint = this.state.form[key].childApiPoint;
          var param = "?"; //`?${this.state.form[key].paramTag}=${e.target.value}`;
          e.target.value.map(
            (i) => (param += `${this.state.form[key].paramTag}=${i}&`)
          );
          this.fetchOptions(this.state.form[key].childKey, endPoint, param);
        }
      }
    );
  };

  fetchOptions = (key, endpoint, param) => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/${endpoint}${param}`, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      })
      .then((res) => {
        this.setState(
          (prevState) => ({
            form: {
              ...prevState.form,
              [key]: {
                ...prevState.form[key],
                options: [...res.data.data],
              },
            },
          }),
          () => {
            this.props.callBack({ ...this.state.form });
          }
        );
      })
      .catch((err) => console.log(err));
  };

  fetchBusinessUnits = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/organizations/api/v1/get-pillar-geography`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        var temp = [];
        Object.keys(res.data).map((key) => {
          temp.push({ id: key, name: key, subUnits: [...res.data[key]] });
        });
        // console.log(temp);
        this.setState(
          (prevState) => ({
            businessUnits: res.data,
            form: {
              ...prevState.form,
              business_unit: {
                ...prevState.form["business_unit"],
                options: [...temp],
              },
            },
          }),
          () => {
            //this.props.callBack({ ...this.state.form });
          }
        );
      })
      .catch((err) => console.log(err));
  };

  handleScroll = (e) => {
    console.log(e);
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      console.log("Scrolling");
    }
  };

  render() {
    const form = { ...this.state.form };
    return (
      <div
        className="merchant-report-container"
        style={{ width: 375, height: 465, borderRadius: "8px 0px 0px 8px" }}
      >
        <h2 className="filter-header">Filters</h2>
        {categorization_filter_whitelist.map((key) => {
          var item = { ...form[key] };

          return item.type === "date-picker" ? (
            <DatePicker
              label={item.label}
              value={item.value}
              onChangeDate={(e) =>
                this.handleChange({ target: { value: e } }, key)
              }
              minDate={item.minDate}
              maxDate={item.maxDate}
              key={key}
            />
          ) : item.type === "multi-select" ? (
            <CustomMultiSlectDropDown
              item={item}
              handleChange={(e) => this.handleMultipleSelectChange(e, key)}
              key={key}
            />
          ) : (
            <CustomDropDown
              item={item}
              handleChange={(e) => this.handleChange(e, key)}
              key={key}
            />
          );
        })}
      </div>
    );
  }
}

function CustomDropDown({ item, handleChange }) {
  return (
    <TextField
      id="standard-select-currency"
      select
      defaultValue=""
      label={
        item.options.length === 0 && item.disabledLabel
          ? item.disabledLabel
          : item.label
      }
      value={item.value}
      onChange={handleChange}
      key={item.key}
      disabled={item.options.length === 0}
    >
      {item.options.map((option) => (
        <MenuItem key={option.id} value={option.id}>
          {option.name}
        </MenuItem>
      ))}
    </TextField>
  );
}

function CustomMultiSlectDropDown({ item, handleChange }) {
  return (
    <TextField
      id="standard-select-currency"
      select
      label={
        item.options.length === 0 && item.disabledLabel
          ? item.disabledLabel
          : item.label
      }
      key={item.key}
      disabled={item.options.length === 0}
      SelectProps={{
        multiple: true,
        value: item.value,
        onChange: handleChange,
        renderValue: (selected) => (
          <div className="multiselect-chip">
            {selected.map((o) => (
              <p key={o}>{item.options.find((e) => e.id === o)?.name}</p>
            ))}
          </div>
        ),
      }}
    >
      {item.options.map((option) => (
        <MenuItem key={option.id} value={option.id}>
          <Checkbox checked={item.value.indexOf(option.id) > -1} />
          {option.name}
        </MenuItem>
      ))}
    </TextField>
  );
}
